import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

.mark {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.mark-color-1 {
  background-color: var(--p-mark-color-blue, #4D71F6);
}
.mark-color-2 {
  background-color: var(--p-mark-color-red, #E35B56);
}
.mark-color-3 {
  background-color: var(--p-mark-color-green, #63C869);
}
.mark-color-4 {
  background-color: var(--p-mark-color-purple, #9379E4);
}
.mark-color-5 {
  background-color: var(--p-mark-color-brown, #B6955D);
}
.mark-color-6 {
  background-color: var(--p-mark-color-yellow, #F0D752);
}

`;
